import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import {
  AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useApi, errMsg } from "@/lib/api";

export const ResetQuotes = () => {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/reset-quotes", { confirm: text });
      toast.success(`Eliminati ${r.data.deleted} preventivi`);
      setOpen(false); setText("");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="bg-slate-900 border border-red-900/60 rounded-lg p-5 flex flex-wrap items-center gap-4" data-testid="reset-quotes-section">
      <div className="mr-auto">
        <h2 className="text-base md:text-lg font-semibold text-red-300">Azzera preventivi</h2>
        <p className="text-xs text-slate-500">Elimina tutti i preventivi, in bozza e inviati. Clienti, catalogo, pacchetti e impostazioni restano.</p>
      </div>
      <AlertDialog open={open} onOpenChange={(v) => { setOpen(v); setText(""); }}>
        <AlertDialogTrigger asChild>
          <Button variant="destructive" data-testid="reset-quotes-btn"><Trash2 className="h-4 w-4 mr-1" />Elimina tutti i preventivi</Button>
        </AlertDialogTrigger>
        <AlertDialogContent className="bg-slate-900 border-slate-700">
          <AlertDialogHeader>
            <AlertDialogTitle>Eliminare tutti i preventivi?</AlertDialogTitle>
            <AlertDialogDescription>L'operazione non si può annullare. Scrivi CANCELLA per confermare.</AlertDialogDescription>
          </AlertDialogHeader>
          <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="CANCELLA" className="font-mono" data-testid="reset-quotes-confirm-input" />
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="reset-quotes-cancel">Annulla</AlertDialogCancel>
            <Button onClick={run} disabled={busy || text.trim().toUpperCase() !== "CANCELLA"} className="bg-red-600 hover:bg-red-700 text-white" data-testid="reset-quotes-confirm">Elimina</Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
};
